<template>
  <div>
    <el-form style="margin-right: 30px" :model="addEditForm" :rules="addEditRules" ref="addEditForm" label-width="100px" class="demo-ruleForm">
      <el-row>
        <el-col :span="12">
          <el-form-item label="老人" prop="personid">
            <el-select v-fixZoom v-model="addEditForm.personid" filterable placeholder="请选择" :clearable="true" style="width:100%;">
              <el-option v-for="item in elderly" :key="item.index" :label="item.name" :value="item.id">
                <span>{{ getSelectElderlyShow(item) }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="订餐日期" prop="date">
            <el-date-picker v-fixZoom style="width: 100%" v-model="addEditForm.date" :clearable="false"
                            type="date" value-format="yyyy-MM-dd" placeholder="xxxx-xx-xx" :picker-options="pickerOptions" @change="changeDate">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="提供类型" prop="types">
            <el-select v-fixZoom multiple v-model="addEditForm.types" filterable placeholder="请选择" :clearable="false" style="width:100%;" >
              <el-option v-for="item in typeArr" :key="item.index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="所属餐厅" prop="restaurantid">
            <el-select v-fixZoom :disabled="!addEditObj.isAdd" v-model="addEditForm.restaurantid" filterable placeholder="请选择" :clearable="true" style="width:100%;" @change="changeRestaurant">
              <el-option v-for="item in restaurants" :key="item.index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="备注" prop="">
        <el-input v-model="addEditForm.desc" placeholder="请输入备注"></el-input>
      </el-form-item>
      <div style="margin: 0 0 0 20px;overflow-y: auto">
        <span style="font-size: 12px;color: #999999">请选择餐厅菜品</span>
        <el-table height="240px" ref="multiple" tooltip-effect="dark" size="mini" border :data="selectIngredientArr" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55" align="center"/>
          <el-table-column label="名称" align="center" prop="name"/>
          <el-table-column label="总卡路里" width="70" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.dish_kcal !== ''">{{scope.row.dish_kcal}} kcal</span>
            </template>
          </el-table-column>
          <el-table-column label="营养成分">
            <template slot-scope="scope">
              <div v-if="scope.row.nutrients !== ''">
                <span>碳水化合物:{{scope.row.nutrients.CHO}}克</span><br>
                <span>蛋白质:{{scope.row.nutrients.PRO}}克</span><br>
                <span>脂肪:{{scope.row.nutrients.FAT}}克</span><br>
                <span>糖类:{{scope.row.nutrients.SUG}}克</span><br>
                <span>膳食纤维:{{scope.row.nutrients.DF}}克</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="数量">
            <template slot-scope="scope">
              <input style="width: 99%;height: 26px;border: 1px solid #cccccc" type="number" v-model="scope.row.cnt" placeholder="请输入数量"/>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-form>
    <div style="height: 50px">
      <el-row style="margin: 0 20px">
        <el-col :span="12">
          <div class="cancel-btn" @click="closeAddEdit()">
            <span>取消</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="send-btn" @click="submitAddEdit('addEditForm')">
            <span>确定</span>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import {adddishperson, updatedishperson} from '../../../api/yanglaoyuan'

export default {
  name: 'addEditOrderMenu',
  model: {
    prop: 'addEditShow',
    event: 'change'
  },
  props: {
    addEditObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      restaurants: [], // 餐厅
      elderly: [], // 老人
      dishes: [], // 菜品
      selectIngredientArr: [],
      selectDishes: [],
      typeArr: [
        {id: 1, name: '早餐'},
        {id: 2, name: '午餐'},
        {id: 4, name: '晚餐'}
      ],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now()
        }
      },
      addEditForm: {
        id: '',
        date: '',
        week: '',
        type: '',
        types: [],
        personid: '',
        desc: '',
        restaurantid: '',
        eid: '',
        dishcnts: []
      },
      addEditRules: {
        personid: [
          {required: true, message: '请选择老人', trigger: 'change'}
        ],
        date: [
          {required: true, message: '请选择日期', trigger: 'change'}
        ],
        restaurantid: [
          {required: true, message: '请选择餐厅', trigger: 'change'}
        ],
        types: [
          {required: true, message: '请选择提供类型', trigger: 'change'}
        ],
        dishcnts: [
          {required: true, message: '请选择菜品', trigger: 'change'}
        ]
      }
      // addShow: false,
      // addForm: {
      //   id: '',
      //   name: '',
      //   cnt: '',
      //   desc: ''
      // },
      // addRules: {
      //   cnt: [
      //     {required: true, message: '请输入数量', trigger: 'blur'}
      //   ],
      //   id: [
      //     {required: true, message: '请选择菜品', trigger: 'change'}
      //   ]
      // }
    }
  },
  created () {
    this.restaurants = this.addEditObj.restaurants
    this.addEditObj.dishes.forEach(item => {
      item.nutrients = item.dish_nutrients !== '' ? JSON.parse(item.dish_nutrients) : ''
      this.dishes.push(item)
    })
    this.elderly = this.addEditObj.elderly
    if (this.addEditObj.isAdd) {
      this.addEditForm.eid = this.$store.state.user.LoginResp.entity_id
    } else {
      let row = this.clone(this.addEditObj.row)
      this.addEditForm = {
        id: row.id,
        date: row.date,
        week: row.week,
        personid: row.personid,
        desc: row.desc,
        restaurantid: row.restaurantid,
        type: '',
        eid: row.eid,
        dishcnts: row.dishcnts
      }
      if (this.addEditObj.row.type === 1) {
        this.addEditForm.types = [1]
      } else if (this.addEditObj.row.type === 2) {
        this.addEditForm.types = [2]
      } else if (this.addEditObj.row.type === 3) {
        this.addEditForm.types = [1, 2]
      } else if (this.addEditObj.row.type === 4) {
        this.addEditForm.types = [3]
      } else if (this.addEditObj.row.type === 5) {
        this.addEditForm.types = [1, 3]
      } else if (this.addEditObj.row.type === 6) {
        this.addEditForm.types = [2, 3]
      } else if (this.addEditObj.row.type === 7) {
        this.addEditForm.types = [1, 2, 3]
      }
    }
  },
  mounted () {
    this.changeRestaurant(this.addEditObj.row.restaurantid)
  },
  methods: {
    handleSelectionChange (selection) {
      // console.log(99, selection)
      this.addEditForm.dishcnts = selection
    },
    changeDate (date) {
      let weekArray = ['日', '一', '二', '三', '四', '五', '六']
      let week = weekArray[new Date(date).getDay()] // 注意此处必须是先new一个Date
      this.addEditForm.week = '星期' + week
    },
    getSelectElderlyShow (item) {
      let elderlyName = item.name && item.name !== '' ? item.name : '--'
      let buildName = item.build_name && item.build_name !== '' ? item.build_name : '--'
      let floorName = item.floor_name && item.floor_name !== '' ? item.floor_name : '--'
      let roomName = item.room && item.room !== '' ? item.room + '号间' : '--'
      let bedName = item.bed_name && item.bed_name !== '' ? item.bed_name + '号床' : '--'
      return elderlyName + ' / ' + buildName + '--' + floorName + '--' + roomName + '--' + bedName
    },
    changeRestaurant (id) {
      let arr = []
      for (let i = 0; i < this.dishes.length; i++) {
        if (id === this.dishes[i].restaurantid) {
          let obj = this.dishes[i]
          obj.desc = ''
          obj.cnt = '1'
          arr.push(obj)
        }
      }
      // this.selectDishes = arr
      this.selectIngredientArr = arr
      if (!this.addEditObj.isAdd) {
        this.getEnd()
      }
    },
    getEnd () {
      let list = []
      for (let i = 0; i < this.selectIngredientArr.length; i++) {
        let item = this.selectIngredientArr[i]
        this.addEditForm.dishcnts.forEach(val => {
          if (val.id === item.id) {
            this.selectIngredientArr[i].cnt = val.cnt
            item.desc = val.desc
            item.cnt = val.cnt
            list.push(item)
          }
        })
      }
      setTimeout(() => {
        list.forEach((row) => {
          this.$refs.multiple.toggleRowSelection(row, true)
        })
      }, 300)
    },
    // selectDishOpen () {
    //   if (this.addEditForm.restaurantid === '') {
    //     this.$message({
    //       message: '请选择餐厅。',
    //       type: 'warning'
    //     })
    //     return
    //   }
    //   if (this.selectDishes.length === 0) {
    //     this.$message({
    //       message: '该餐厅暂无菜品提供。',
    //       type: 'warning'
    //     })
    //     return
    //   }
    //   this.addForm = {
    //     id: '',
    //     name: '',
    //     cnt: '',
    //     desc: ''
    //   }
    //   this.addShow = true
    // },
    // changeItem (id) {
    //   for (let i = 0; i < this.selectDishes.length; i++) {
    //     if (id === this.selectDishes[i].id) {
    //       this.addForm.name = this.selectDishes[i].name
    //     }
    //   }
    // },
    // selectRestaurant (formName) {
    //   this.$refs[formName].validate((valid) => {
    //     if (valid) {
    //       let isHave = false
    //       for (let i = 0; i < this.addEditForm.dishcnts.length; i++) {
    //         if (this.addForm.id === this.addEditForm.dishcnts[i].id) {
    //           isHave = true
    //           this.$confirm('已选过菜品, 是否替换已选菜品?', '提示', {
    //             confirmButtonText: '确定',
    //             cancelButtonText: '取消',
    //             type: 'error'
    //           }).then(() => {
    //             this.addEditForm.dishcnts[i] = this.addForm
    //             this.addShow = false
    //           })
    //         }
    //       }
    //       if (!isHave) {
    //         this.addEditForm.dishcnts.push(this.addForm)
    //         this.addShow = false
    //       }
    //     }
    //   })
    // },
    // handleClose (id) {
    //   let index = 0
    //   for (let i = 0; i < this.addEditForm.dishcnts.length; i++) {
    //     if (id === this.addEditForm.dishcnts[i].id) {
    //       break
    //     }
    //     index++
    //   }
    //   this.addEditForm.dishcnts.splice(index, 1)
    //   // console.log(this.addEditForm.dishcnts)
    // },
    closeAddEdit () {
      this.$emit('change', false)
    },
    submitAddEdit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let sendtype = 0
          for (let i = 0; i < this.addEditForm.types.length; i++) {
            sendtype = sendtype + this.addEditForm.types[i]
          }
          let dishcnts = []
          for (let i = 0; i < this.addEditForm.dishcnts.length; i++) {
            let obj = {
              id: this.addEditForm.dishcnts[i].id,
              cnt: parseInt(this.addEditForm.dishcnts[i].cnt),
              desc: this.addEditForm.dishcnts[i].desc,
              dishpackageid: 0,
              dishpackagename: ''
            }
            dishcnts.push(obj)
          }
          if (this.addEditObj.isAdd) {
            let data = {
              date: this.addEditForm.date,
              week: this.addEditForm.week,
              type: sendtype,
              personid: this.addEditForm.personid,
              desc: this.addEditForm.desc,
              restaurantid: this.addEditForm.restaurantid,
              eid: this.addEditForm.eid,
              dishcnts: dishcnts
            }
            adddishperson(data).then(res => {
              this.$notify({title: '成功', message: '成功新增订餐', type: 'success', duration: 2000})
              this.$emit('updateTable')
              this.$emit('change', false)
            })
          } else {
            let data = {
              id: this.addEditForm.id,
              date: this.addEditForm.date,
              week: this.addEditForm.week,
              type: sendtype,
              personid: this.addEditForm.personid,
              desc: this.addEditForm.desc,
              restaurantid: this.addEditForm.restaurantid,
              eid: this.addEditForm.eid,
              dishcnts: dishcnts
            }
            updatedishperson(data).then(res => {
              this.$notify({title: '成功', message: '成功编辑订餐', type: 'success', duration: 2000})
              this.$emit('updateTable')
              this.$emit('change', false)
            })
          }
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/addEditOrderMenu.vue